export default __webpack_public_path__ + "static/summit2025-01d1e5d6c7dfea48ec71d9859149ebca.svg";